import axios from "axios";
import { environment } from "configs/environment";

export const http = axios.create({ baseURL: environment.API.HOST });